import Vue from "vue";
import Router from "vue-router";

import pagos from "../components/reportes/pagos/pagos.vue";
import login from "../components/loginn/loginn.vue";
import cuatr4 from "../components/404/index.vue";

import impuestos from "../components/reportes/impuestos/impuestos.vue";
import ajustesCargos from "../components/reportes/ajustesCargos/index.vue";
import liquidacionesNatura from "../components/reportes/liquidacionesNatura/index.vue";
import resumenLiquidacionesAbierto from "../components/reportes/resumenLiquidacionesAbierto/index.vue";




import resumenbanco from "../components/reportes/resumenbanco/index.vue";
import bancoForconi from "../components/reportes/bancoForconi/resumenbanco.vue";

import liquidaciones from "../components/reportes/liquidaciones/index.vue";
import ventasLiquiDet from "../components/reportes/ventasLiquiDet/ventasLiquiDet.vue";
import resumenloteequi from "../components/reportes/resumenloteequi/resumenloteequi.vue";
import ventasLiquiDet2 from "../components/reportes/ventasLiquiDet2/index.vue";
import cuponesLiquidados from "../components/reportes/cuponesLiquidados/index.vue";
import informeRetIIBB from "../components/reportes/informeRetIIBB/index.vue";

import vtaPorComercio from "../components/estadisticas/vtaPorComercio/index.vue";

import cuponesEC from "../components/reportes/cuponesEC/index.vue";

import chequesTN from "../components/reportes/chequesTN/index.vue";

import resumenec from "../components/reportes/resumenec/index.vue";
import loteEquipoPagado from "../components/reportes/loteEquipoPagado/index.vue";

import ventasPagosPorMes from "../components/estadisticas/ventasPagosPorMes/index.vue";
import resumenvtaTarjeta from "../components/estadisticas/resumenvtatarjeta/resumenvtatarjeta.vue";
import ventaTerminal from "../components/estadisticas/ventaTerminal/ventaTerminal.vue";
import ventaDia from "../components/estadisticas/ventaDia/ventaDia.vue";
import analisisCostos from "../components/estadisticas/analisisCostos/index.vue";

import analisisCostosTerminal from "../components/estadisticas/analisisCostosTerminal/index.vue";

import cuponesLiqDet from "../components/reportes/cuponesLiqDet/index.vue";
import liquidacionNJ from "../components/reportes/liquidacionNJ/index.vue";
import liquidacionNJnvo from "../components/reportes/liquidacionNJnvo/index.vue";
import devoluciones from "../components/reportes/devoluciones/index.vue";
import liquidacionesDet from "../components/reportes/liquidacionesDet/liquidacionesDet.vue";

import liquidacionesTarjeta from "../components/reportes/liquidacionesTarjeta/index.vue";

// config

import terminales from "../components/configs/termianles/index.vue";

import sidecreer from "../components/configs/sidecreer/index.vue";
import trx from "../components/configs/trx/index.vue";
import conciliador from "../components/configs/conciliador/index.vue";
import archivos from "../components/configs/archivos/index.vue";
import cargaTransferencias from "../components/configs/cargaTransferencias/index.vue";
import cargarArchivoTN from "../components/configs/cargarArchivoTN/index.vue";
import cargarArchivoNatura from "../components/configs/cargarArchivoNatura/index.vue";
import cargarNaturaCreation from "../components/configs/cargarNaturaCreation/index.vue";



import cargarArchivoFD from "../components/configs/cargarArchivoFD/index.vue";
import cargaArchivoSC from "../components/configs/cargaArchivoSC/index.vue";

import archivosFiserv from "../components/configs/archivosFiserv/index.vue";

//import trxtarjetas from '../components/posintegrado/trxtarjetas/index.vue'

// LOTE IP POS
import trxcupones from "../components/posintegrado/trxcupones/index.vue";
import resumenLoteEquipo from "../components/posintegrado/resumenLoteEquipo/index.vue";
import informeVendedor from "../components/posintegrado/informeVendedor/index.vue";
import informeVendedorTodos from "../components/posintegrado/informeVendedorTodos/index.vue";
import resLotePosTarjeta from "../components/posintegrado/resLotePosTarjeta/index.vue";
import detalleCuponesVtas from "../components/posintegrado/detalleCuponesVtas/index.vue";
import ventasConciliador from "../components/posintegrado/ventasConciliador/index.vue";

import detalleCuponesFechaRecibido from "../components/posintegrado/detalleCuponesFechaRecibido/index.vue";

import goCuotasVentasSuc from "../components/reportes/goCuotasVentasSuc/index.vue";

import goCuotasCuponesLiq from "../components/reportes/goCuotasCuponesLiq/index.vue";
import goCuotasLiq from "../components/reportes/goCuotasLiq/index.vue";

import iibbxProvincia from "../components/reportes/iibbxProvincia/index.vue";
import resumenQrDni from "../components/reportes/resumenQrDni/index.vue";

import api from "../components/instructivos/api/index.vue";

import mpMovimientos from "../components/reportes/mpMovimientos/index.vue";
import mpResumen from "../components/reportes/mpResumen/index.vue";

import mpCobrosPagosDia from "../components/reportes/mpCobrosPagosDia/index.vue";
import cobroPorTarjeta from "../components/estadisticas/cobroPorTarjeta/index.vue";

import cobroTerminal from "../components/estadisticas/cobroTerminal/index.vue";

import resumenQrDniRet from "../components/reportes/resumenQrDniRet/index.vue";
import facturacion from "../components/fs/facturas/index.vue";
import datTransacciones from "../components/fs/datTransacciones/index.vue";

import diaTerminalLote from "../components/estadisticas/diaTerminalLote/index.vue";

import reps_alta from "../components/reps/altas/index.vue";
import reporteAlta from "../components/reps/reporte/index.vue";

import crearLp from "../components/ecash/crear/index.vue";

import linksPago from "../components/ecash/linksPago/index.vue";

import operaciones from "../components/ecash/operaciones/index.vue";

import configTienda from "../components/ecash/configTienda/index.vue";

import debAuto from "../components/configs/debAuto/index.vue";
import profile from "../components/configs/profile/index.vue";

import loteipTr from "../components/fs/loteipTr/index.vue";

import infoCabal from "../components/fs/infoCabal/index.vue";

import cuponesLiquidadosPromo from "../components/reportes/cuponesLiquidadosPromo/index.vue";

//cuota a cuota

import pendienteCancelar from "../components/cuotaCuota/pendienteCancelar/index.vue";

import completo from "../components/cuotaCuota/completo/index.vue";
import cuotaCuota from "../components/cuotaCuota/cuotaCuota/index.vue";

// PP

import ppCupones from "../components/reportes/ppCupones/index.vue";
import ppLiquidaciones from "../components/reportes/ppLiquidaciones/index.vue";
import ppCuponesDia from "../components/reportes/ppCuponesDia/index.vue";
import liqLapos from "../components/reportes/liqLapos/index.vue";
import comisiones from "../components/reportes/comisiones/index.vue";
import resumenPagos from "../components/reportes/resumenPagos/index.vue";
import infoEventos from "../components/reportes/infoEventos/index.vue";
import pixMovimientos from "../components/reportes/pixMovimientos/index.vue";
import resPIXPagoDia from "../components/reportes/pixPagoDia/index.vue";
import recuperarAcceso from "../components/recuperar/index.vue";



// natura

import naturaCreationSubido from "../components/reportes/naturaCreationSubido/index.vue";
import naturaCreationUnido from "../components/reportes/naturaCreationUnido/index.vue";
import naturaCreationConciliado from "../components/reportes/naturaCreationConciliado/index.vue";
import naturaCreationReprocesar from "../components/reportes/naturaCreationReprocesar/index.vue";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "*", component: cuatr4 },
    {
      path: "/natura/creation/reprocesar",
      name: "naturaCreationReprocesar",
      component: naturaCreationReprocesar
    },
    {
      path: "/natura/creation/conciliado",
      name: "naturaCreationConciliado",
      component: naturaCreationConciliado
    },
    {
      path: "/natura/creation/subido",
      name: "naturaCreationSubido",
      component: naturaCreationSubido
    },
    {
      path: "/natura/creation/sin-split",
      name: "naturaCreationUnido",
      component: naturaCreationUnido
    },
    {
      path: "/",
      name: "loginn",
      component: login
    },
    {
      path: "/acceso/recuperar",
      name: "recuperarAcceso",
      component: recuperarAcceso
    },

    {
      path: "/estadisticas/comercios/ventas",
      name: "vtaPorComercio",
      component: vtaPorComercio
    },
    {
      path: "/pix/movimientos",
      name: "pixMovimientos",
      component: pixMovimientos
    },
    {
      path: "/pix/resumen/dia",
      name: "resPIXPagoDia",
      component: resPIXPagoDia
    },
    {
      path: "/config/carga/transferencias",
      name: "cargaTransferencias",
      component: cargaTransferencias
    },
    {
      path: "/config/TN",
      name: "cargarArchivoTN",
      component: cargarArchivoTN
    },

    {
      path: "/reportes/natura/conciliador",
      name: "cargarArchivoNatura",
      component: cargarArchivoNatura
    },
    {
      path: "/natura/conciliador-creation",
      name: "cargarNaturaCreation",
      component: cargarNaturaCreation
    },

    {
      path: "/config/fd",
      name: "cargarArchivoFD",
      component: cargarArchivoFD
    },
    {
      path: "/config/sidecreer/carga-archivo",
      name: "cargaArchivoSC",
      component: cargaArchivoSC
    },
    {
      path: "/reportes/comisiones",
      name: "comisiones",
      component: comisiones
    },
    {
      path: "/reportes/liquidaciones/natura",
      name: "liquidacionesNatura",
      component: liquidacionesNatura
    },
    {
      path: "/reportes/devoluciones",
      name: "devoluciones",
      component: devoluciones
    },
    {
      path: "/reportes/liquidaciones/resumen-abierto",
      name: "resumenLiquidacionesAbierto",
      component: resumenLiquidacionesAbierto
    },

    {
      path: "/reportes/info/eventos",
      name: "infoEventos",
      component: infoEventos
    },
    {
      path: "/reportes/resumen/pagos",
      name: "resumenPagos",
      component: resumenPagos
    },
    {
      path: "/404",
      name: "404",
      component: cuatr4
    },
    {
      path: "/dashboard",
      name: "pagos",
      component: pagos
    },

    {
      path: "/reportes/liqLapos",
      name: "liqLapos",
      component: liqLapos
    },
    {
      path: "/reportes/ajustesCargos",
      name: "ajustesCargos",
      component: ajustesCargos
    },
    {
      path: "/reportes/impuestos",
      name: "impuestos",
      component: impuestos
    },
    {
      path: "/reportes/resumenbanco",
      name: "resumenbanco",
      component: resumenbanco
    },
    {
      path: "/reportes/resumenbanconvo",
      name: "resumenbanconvo",
      component: bancoForconi
    },
    {
      path: "/reportes/resumenec",
      name: "resumenec",
      component: resumenec
    },
    {
      path: "/reportes/liquidaciones",
      name: "liquidaciones",
      component: liquidaciones
    },
    {
      path: "/reportes/ventasLiquiDet",
      name: "ventasLiquiDet",
      component: ventasLiquiDet
    },
    {
      path: "/otrosReportes/liquidacionesTarjeta",
      name: "liquidacionesTarjeta",
      component: liquidacionesTarjeta
    },
    {
      path: "/reportes/resumenloteequi",
      name: "resumenloteequi",
      component: resumenloteequi
    },
    {
      path: "/reportes/ventasLiquiDet2",
      name: "ventasLiquiDet2",
      component: ventasLiquiDet2
    },
    {
      path: "/config/terminales",
      name: "terminales",
      component: terminales
    },
    {
      path: "/config/debAuto",
      name: "debAuto",
      component: debAuto
    },

    {
      path: "/config/profile",
      name: "profile",
      component: profile
    },

    {
      path: "/config/sidecreer",
      name: "sidecreer",
      component: sidecreer
    },
    {
      path: "/config/fiserv/files",
      name: "archivosFiserv",
      component: archivosFiserv
    },
    {
      path: "/reportes/cuponesLiquidados",
      name: "cuponesLiquidados",
      component: cuponesLiquidados
    },
    {
      path: "/reportes/cuponesEC",
      name: "cuponesEC",
      component: cuponesEC
    },
    {
      path: "/reportes/cupones/liquidados/promo",
      name: "cuponesLiquidadosPromo",
      component: cuponesLiquidadosPromo
    },

    {
      path: "/reportes/chequesTN",
      name: "chequesTN",
      component: chequesTN
    },
    {
      path: "/reportes/loteEquipoPagado",
      name: "loteEquipoPagado",
      component: loteEquipoPagado
    },
    {
      path: "/estadisticas/ventasPagosPorMes",
      name: "ventasPagosPorMes",
      component: ventasPagosPorMes
    },
    {
      path: "/estadisticas/resumenvtatarjeta",
      name: "resumenvtatarjeta",
      component: resumenvtaTarjeta
    },
    {
      path: "/estadisticas/ventaTerminal",
      name: "ventaTerminal",
      component: ventaTerminal
    },
    {
      path: "/estadisticas/ventaDia",
      name: "ventaDia",
      component: ventaDia
    },
    {
      path: "/estadisticas/analisisCostos",
      name: "analisisCostos",
      component: analisisCostos
    },
    {
      path: "/estadisticas/analisisCostosTerminal",
      name: "analisisCostosTerminal",
      component: analisisCostosTerminal
    },

    {
      path: "/reportes/cuponesLiqDet",
      name: "cuponesLiqDet",
      component: cuponesLiqDet
    },
    {
      path: "/reportes/liquidacionNJ",
      name: "liquidacionNJ",
      component: liquidacionNJ
    },
    {
      path: "/reportes/liquidacionNJnvo",
      name: "liquidacionNJnvo",
      component: liquidacionNJnvo
    },
    {
      path: "/reportes/liquidacionesDet",
      name: "liquidacionesDet",
      component: liquidacionesDet
    },
    {
      path: "/config/trx",
      name: "trx",
      component: trx
    },
    {
      path: "/config/conciliador",
      name: "conciliador",
      component: conciliador
    },
    {
      path: "/config/archivos",
      name: "archivos",
      component: archivos
    },
    {
      path: "/loteip/trxcupones",
      name: "trxcupones",
      component: trxcupones
    },
    {
      path: "/loteip/resumen/lote-equipo",
      name: "resumenLoteEquipo",
      component: resumenLoteEquipo
    },
    {
      path: "/loteip/cupones/ventas",
      name: "detalleCuponesVtas",
      component: detalleCuponesVtas
    },

    {
      path: "/reportes/conciliador/ventas",
      name: "ventasConciliador",
      component: ventasConciliador
    },

    {
      path: "/loteip/lote/tarjetas",
      name: "resLotePosTarjeta",
      component: resLotePosTarjeta
    },

    {
      path: "/loteip/informeVendedor",
      name: "informeVendedor",
      component: informeVendedor
    },
    {
      path: "/loteip/informeVendedorTodos",
      name: "informeVendedorTodos",
      component: informeVendedorTodos
    },
    {
      path: "/loteip/detalleCuponesFechaRecibido",
      name: "detalleCuponesFechaRecibido",
      component: detalleCuponesFechaRecibido
    },
    {
      path: "/reportes/resumenQrDni",
      name: "resumenQrDni",
      component: resumenQrDni
    },
    {
      path: "/reportes/provincias/iibb",
      name: "iibbxProvincia",
      component: iibbxProvincia
    },
    {
      path: "/reportes/gocuotas/sucursal/ventas",
      name: "goCuotasVentasSuc",
      component: goCuotasVentasSuc
    },
    {
      path: "/reportes/gocuotas/cupones/liquidados",
      name: "goCuotasCuponesLiq",
      component: goCuotasCuponesLiq
    },

    {
      path: "/reportes/gocuotas/liquidaciones",
      name: "goCuotasLiq",
      component: goCuotasLiq
    },

    {
      path: "/instructivos/api",
      name: "api",
      component: api
    },
    {
      path: "/reportes/mpMovimientos",
      name: "mpMovimientos",
      component: mpMovimientos
    },
    {
      path: "/reportes/mpResumen",
      name: "mpResumen",
      component: mpResumen
    },
    {
      path: "/reportes/mpCobrosPagosDia",
      name: "mpCobrosPagosDia",
      component: mpCobrosPagosDia
    },
    {
      path: "/estadisticas/cobroPorTarjeta",
      name: "cobroPorTarjeta",
      component: cobroPorTarjeta
    },
    {
      path: "/reportes/resumenQrDniRet",
      name: "resumenQrDniRet",
      component: resumenQrDniRet
    },
    {
      path: "/estadisticas/cobroTerminal",
      name: "cobroTerminal",
      component: cobroTerminal
    },
    {
      path: "/fs/facturas",
      name: "facturacion",
      component: facturacion
    },
    {
      path: "/fs/loteip",
      name: "loteipTr",
      component: loteipTr
    },
    {
      path: "/user/accesos/cabal",
      name: "infoCabal",
      component: infoCabal
    },

    {
      path: "/estadisticas/diaTerminalLote",
      name: "diaTerminalLote",
      component: diaTerminalLote
    },
    {
      path: "/reps/altas",
      name: "repsAltas",
      component: reps_alta
    },
    {
      path: "/reps/reporte",
      name: "reporteAlta",
      component: reporteAlta
    },
    {
      path: "/ecash/crear",
      name: "crearLp",
      component: crearLp
    },
    {
      path: "/ecash/linkpago",
      name: "linksPago",
      component: linksPago
    },
    {
      path: "/ecash/operaciones",
      name: "operaciones",
      component: operaciones
    },
    {
      path: "/ecash/configTienda",
      name: "configTienda",
      component: configTienda
    },
    {
      path: "/cuotaCuota/pendienteCancelar",
      name: "pendienteCancelar",
      component: pendienteCancelar
    },
    {
      path: "/cuotaCuota/completo",
      name: "completo",
      component: completo
    },
    {
      path: "/cuotaCuota/cuotaCuota",
      name: "cuotaCuota",
      component: cuotaCuota
    },
    {
      path: "/reportes/ppCupones",
      name: "ppCupones",
      component: ppCupones
    },
    {
      path: "/reportes/ppLiquidaciones",
      name: "ppLiquidaciones",
      component: ppLiquidaciones
    },
    {
      path: "/reportes/ppCuponesDia",
      name: "ppCuponesDia",
      component: ppCuponesDia
    },
    {
      path: "/reportes/informeRetIIBB",
      name: "informeRetIIBB",
      component: informeRetIIBB
    },
    {
      path: "/fs/dat-transacciones",
      name: "datTransacciones",
      component: datTransacciones
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js